import { Box, InputAdornment, useMediaQuery, useTheme } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import SearchIcon from '@mui/icons-material/Search';
import * as _ from 'lodash';
// import { useGetWorkordersCurrent } from '../hooks/workorderHooks';
import { useSearchData } from '../hooks/searchOptionHook';
import { useNavigate } from 'react-router-dom';
import { cookie } from '../Utils/Cookies/cookie';

function SearchComponent() {
  const [val, setVal] = useState<any>('');
  const [hideLabel, setHideLabel] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [enableSearchAPI, setenableSearchAPI] = useState(true);
  const [personName, setPersonName] = React.useState<any>([]);
  const [countPerson, setCountPerson] = React.useState<any>('');

  const token = cookie.get('token');
  const { data: getAllSearchData, isLoading } = useSearchData(!!token && enableSearchAPI);

  const navigate = useNavigate();

  const handleChange = (event) => {
    setenableSearchAPI(false);
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
    setCountPerson(event.target.value.length);
    const filterData = _.filter(getAllSearchData, (data, index) =>
      event.target.value.includes(data?.category)
    );
    setData(filterData);
  };

  useEffect(() => {
    if (!isLoading) {
      if (enableSearchAPI) {
        setData(getAllSearchData);
        setenableSearchAPI(false);
      }
      setenableSearchAPI(false);
    }
  }, [data.length, getAllSearchData?.length]);

  //! static response for future use :
  // const autoCompleteOptions = [
  //   {
  //     title: 'Car Cleaning 1204-1244-1241-1241',
  //     value: 'Car Cleaning',
  //     category: 'Workorders',
  //   },
  //   {
  //     title: 'Car Cleaning 1204-1244-1241-1241',
  //     value: 'Car Cleaning',
  //     category: 'Workorders',
  //   },
  //   {
  //     title: 'Car Cleaning 1204-1244-1241-1241',
  //     value: 'Car Cleaning',
  //     category: 'Workorders',
  //   },
  //   {
  //     title: 'Clippers 1204-1244-1241-1241',
  //     value: 'Clippers',
  //     category: 'Parts',
  //   },
  //   {
  //     title: 'Clippers 1204-1244-1241-1241',
  //     value: 'Clippers',
  //     category: 'Parts',
  //   },
  //   {
  //     title: 'Clippers 1204-1244-1241-1241',
  //     value: 'Clippers',
  //     category: 'Parts',
  //   },
  //   {
  //     title: 'Ceat Tyre 1204-1244-1241-1241',
  //     value: 'Ceat Tyre',
  //     category: 'Products',
  //   },
  //   {
  //     title: 'Ceat Tyre 1204-1244-1241-1241',
  //     value: 'Ceat Tyre',
  //     category: 'Products',
  //   },
  //   {
  //     title: 'Ceat Tyre 1204-1244-1241-1241',
  //     value: 'Ceat Tyre',
  //     category: 'Products',
  //   },
  // ];

  const GroupHeader = styled('div')(() => ({
    position: 'sticky',
    top: '-8px',
    padding: '4px 10px',
    color: '#333333',
    backgroundColor: '#F4F9FF',
  }));

  // const options = autoCompleteOptions.map((option) => {
  //   const firstLetter = option.title[0].toUpperCase();
  //   return {
  //     firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
  //     ...option,
  //   };
  // });

  const names: string[] = [
    'Workorders',
    'Part',
    'Product',
    'Raw Material',
    'Machine',
    'Process',
    'Workers',
  ];

  //! all relative dynamic paths for particuler parts,parts Etc...

  const category = {
    Workorders: '/completion-report',
    Part: '/part-details',
    Product: '/edit-product',
    'Raw Material': '/raw-material-details',
    Machine: '/machine-details',
    Process: '/process-details',
    Workers: '/worker-detail',
    'Desktop User': '/desktop-user-details',
  };
  const isChangeWidth =
    location.pathname.startsWith('/mobile-user-details') ||
    location.pathname.startsWith('/desktop-user-details');
  const theme = useTheme();
  const isMdScreen = useMediaQuery(theme.breakpoints.only('md'));
  const BoxWrapper = styled(Box)(() => ({
    display: 'inline-flex',
    boxSizing: 'border-box',
    height: '40px',
    borderRadius: '4px',
    border: '1px solid rgba(205, 205, 205, 1)',
    background: 'rgba(246, 246, 246, 1)',
    // boxShadow: '0px 2px 10px rgba(40, 40, 40, 0.1)',
    '.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
      padding: '0 !important',
    },
    '.dropdown': {
      background: '#F4F9FF',
      borderRadius: '0 4px 4px 0px',
      border: 'none !important',
      padding: '0px !important',
      width: personName?.length ? '160px' : '80px',
      height: '40px !important',
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    },
    '.autocomplete': {
      '& .MuiOutlinedInput-root': {
        padding: '0px !important',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
      '& .MuiAutocomplete-inputFocused': {},
      // width: isMdScreen ? (isChangeWidth ? '220px' : '300px') : '300px',
      width: isMdScreen ? '250px' : '300px',
      '& .MuiAutocomplete-input': {
        padding: '8px 0px 0px 0px !important',
      },
    },

    '.search-input': {
      // width: isMdScreen ? (isChangeWidth ? '220px' : '300px') : '300px',
      width: isMdScreen ? '250px' : '300px',
      fontSize: '16px',
    },
    '.search-icon': {
      padding: '8px 0.5px 0px 6.5px',
      color: 'gray',
    },
    '.custom-checkbox': {
      '& .MuiSvgIcon-root': {
        fontSize: '70px !important',
        borderRadius: '50px !important',
      },
    },
    '.all-set': {
      border: '1px solid red',
      PaddingBottom: '10px',
    },
  }));
  // return <Box>Coming Soon...</Box>;
  return (
    <BoxWrapper display={'flex'}>
      <Autocomplete
        className='autocomplete'
        forcePopupIcon={false}
        id='grouped-demo'
        options={data}
        groupBy={(option: any) => option?.category}
        getOptionLabel={(option) => {
          return option.title || '';
        }}
        onChange={(e, value) => {
          setHideLabel(true);
          navigate(`${category[value.category]}/${value?.value}`);
          setVal(value);
        }}
        onBlur={() => setHideLabel(false)}
        renderInput={(params) => (
          <TextField
            {...params}
            className='search-input'
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchIcon className='search-icon' />
                </InputAdornment>
              ),
            }}
            placeholder='Search'
          />
        )}
        renderGroup={(params) => (
          <li>
            <GroupHeader>{params.group}</GroupHeader>
            <ul>{params.children}</ul>
          </li>
        )}
      />
      {/* <FormControl>
        <InputLabel id='demo-multiple-checkbox-label' shrink={false}>
          {!personName.length ? 'All' : ''}
        </InputLabel>
        <Select
          labelId='demo-multiple-checkbox-label'
          id='demo-multiple-checkbox'
          multiple
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput label='Tag' />}
          renderValue={(selected: any) => {
            if (!selected.length) {
              return selected.join(', ');
            } else {
              return `${countPerson} filters applied`;
            }
          }}
          MenuProps={MenuProps}
          className='dropdown'
        >
          {names.map((name: string, ind: number) => (
            <MenuItem key={ind} value={name}>
              <Checkbox
                // icon={<CheckBoxOutlineBlankOutlinedIcon />}
                icon={<CheckboxIcon />}
                // checkedIcon={<CheckBoxOutlinedIcon color='warning' />}
                checkedIcon={<CheckboxFilledIcon />}
                checked={personName?.indexOf(name) > -1}
                className='custom-checkbox'
              />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl> */}
    </BoxWrapper>
  );
}

export default SearchComponent;
